// DOM container management for search results

/**
 * Initialize and get results container
 * @param {jQuery} $container - Main container element
 * @returns {jQuery} Results container element
 */
export function getOrCreateResultsContainer($container) {
    let $resultsContainer = $container.find('#fulltext-results-container');
    if (!$resultsContainer.length) {
        $resultsContainer = $('<div id="fulltext-results-container"></div>');
        $container.append($resultsContainer);
    }
    return $resultsContainer;
}

/**
 * Initialize and get pagination container
 * @param {jQuery} $container - Main container element
 * @param {jQuery} $resultsContainer - Results container element
 * @returns {jQuery} Pagination container element
 */
export function getOrCreatePaginationContainer($container, $resultsContainer) {
    let $pagesContainer = $container.find('.pages').first();
    if (!$pagesContainer.length) {
        $pagesContainer = $('<nav class="pages" aria-label="Page navigation"></nav>');
        $pagesContainer.insertAfter($resultsContainer);
    }
    return $pagesContainer;
}

/**
 * Prepare container for rendering
 * @param {jQuery} $container - Main container element
 * @returns {Object} Container elements and state
 */
export function prepareContainer($container) {
    $container.removeClass('loading');
    
    const $spinner = $container.find('.fulltext-loading-spinner');
    if ($spinner.length) $spinner.addClass('d-none').hide();
    
    const $resultsContainer = getOrCreateResultsContainer($container);
    const $pagesContainer = getOrCreatePaginationContainer($container, $resultsContainer);
    
    // Clean up existing morph wrappers
    const $existingMorphWrappers = $resultsContainer.find('.morph-wrapper');
    if ($existingMorphWrappers.length > 0) $existingMorphWrappers.remove();
    
    const $allExistingResults = $resultsContainer.find('.search-result-item');
    const hasOldResults = $allExistingResults.length > 0;
    
    return {
        $resultsContainer,
        $pagesContainer,
        $allExistingResults,
        hasOldResults,
        resultsContainerEl: $resultsContainer[0]
    };
}

